export function ResourceCategoriesFilter() {
    const resourceCategoryFilters =
        document.querySelectorAll('[name=resource-category]');
    const resources = document.querySelectorAll('.resource');

    for (const filter of resourceCategoryFilters) {
        filter.addEventListener('change', e => {
            const filterID = parseInt(e.target.value);

            for (const resource of resources) {
                resource.classList.remove('d-none');
            }

            if (filterID) {
                const filteredResources =
                    [...resources].filter(resource => {
                        return !JSON.parse(resource.dataset.resourceCategories).includes(filterID);
                    });

                for (const resource of filteredResources) {
                    resource.classList.add('d-none');
                }
            }
        });
    }
}
